import { fichier } from "../services/restauratrice/RestauratriceRequest";

export const returnImageLink = (id) => {
    if (id != null && id != undefined) {
        return fichier(id)
    } else {
        return "";
    }

}